import { Formatters } from '../modules'
import { FIELD_ROOM_ID, FIELD_PAYMENT, FIELD_CONTRACT_CUSTOMER, SUMMARY_SUM, SUMMARY_PLAIN, FILTERS_SELECT_DATE } from './_common'

const FORMATTER_UTILTIY = (type) => (_, record) => {
  const utility = record.utilities.filter(u => u.type === type)[0] || {}
  return Formatters.money(utility.quantity || 0)
}

const FIELD_UTILTIY = (label, type) => ({
  label,
  formatter: FORMATTER_UTILTIY(type),
  classes: 'right aligned',
  type: 'money',
  summary: SUMMARY_SUM((record) => FORMATTER_UTILTIY(type)(null, record)),
})

export default {
  props: {
    summary: {
      label: '摘要',
      formatter: (_, record) => {
        const summary = []
        for (const utility of record.utilities) {
          if (utility.quantity)
            summary.push(`${Formatters.utility_label(utility.type)} ${utility.quantity} ${Formatters.utility_unit(utility.type)}`)
        }
        return summary.join('; ')
      },
    },
    _room: FIELD_ROOM_ID(),
    electricity: FIELD_UTILTIY('电', 'electricity'),
    water: FIELD_UTILTIY('冷水', 'water'),
    hot_water: FIELD_UTILTIY('热水', 'hot_water'),
    kitchen: FIELD_UTILTIY('厨房', 'kitchen'),
    payment_method: FIELD_PAYMENT(),
    customers_summary: FIELD_CONTRACT_CUSTOMER(),
    total_income: {
      label: '金额',
      type: 'money',
      classes: 'right aligned positive',
      summary: SUMMARY_SUM('total_income'),
    },
    time_created: {
      label: '充值时间',
      type: 'time',
      classes: 'collapsing hide-in-mobile',
      summary: SUMMARY_PLAIN('合计'),
    },
    note: {
      label: '备注',
      maxlength: 20,
      tooltip: 'top center',
      classes: 'collapsing hide-in-mobile',
    },
  },
  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
    },
  },
  layouts: {
    default: {
      layout: [
        'time_created',
        '_room',
        'customers_summary',
        'water',
        'hot_water',
        'electricity',
        'kitchen',
        'total_income',
        'payment_method',
        'note',
      ],
    },
    in_room: {
      layout: [
        'time_created',
        'water',
        'hot_water',
        'electricity',
        'kitchen',
        'total_income',
        'payment_method',
        'note',
      ],
    },
    detail: {
      layout: [
        '_room',
        'customers_summary',
        'water',
        'hot_water',
        'electricity',
        'total_income',
        'payment_method',
        'time_created',
        'note',
      ],
    },
  },

  filters: {
    search: {
      type: 'search',
      keys: [
        'note',
      ],
    },
    date: FILTERS_SELECT_DATE(),
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/charge.js